module.exports = __webpack_public_path__ + "static/media/check-circle-regular.af022f41.svg";